import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
  TextField,
  Button,
  Link,
} from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import Loader from "../components/Loader";
import {
  client,
  createAuth,
  createAuthenticatedClient,
  createMessagesClient,
} from "lib/api";
import { useStore } from "lib/store";
import { actionLogin, actionLogout } from "lib/store/Actions";
import useRouter from "use-react-router";

const styles = (theme: Theme) =>
  createStyles({
    main: {},
    input: { width: "100%", marginTop: 15, marginBottom: 15 },
    buttons: { textAlign: "right" },
    forgot: {
      marginBottom: 10,
      marginRight: 10,
      cursor: "pointer",
    },
  });

type onForgot = () => void;

interface Props extends WithStyles<typeof styles> {
  className?: string;
  onForgot: onForgot;
}

const LoginForm: React.FC<Props> = ({ classes, className, onForgot }) => {
  const [, dispatch] = useStore();
  const { history } = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    const r = await client.POST("/api/auth/login", {
      body: { email, password },
    });
    if (r.error) {
      setLoading(false);
      setError("Accès refusé");
      setPassword("");
    } else {
      const auth = createAuth(r.data.token, () => {
        dispatch(actionLogout());
        history.push("/");
      });
      const messages = createMessagesClient(auth);
      const client = createAuthenticatedClient(auth);
      const org = await client.GET("/api/orgs/{org}", {
        params: { path: { org: auth.user.org } },
      });
      if (!org.error) {
        dispatch(actionLogin(auth.user, client, org.data, messages));
      }
    }
  };

  const handleChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      switch (field) {
        case "email":
          setEmail(value);
          break;
        case "password":
          setPassword(value);
          break;
      }
      if (error) {
        setError("");
      }
    };

  return (
    <div className={className}>
      <h2>Se connecter</h2>
      <Loader show={loading}>
        <form onSubmit={handleSubmit}>
          <TextField
            name="email"
            className={classes.input}
            value={email}
            onChange={handleChange("email")}
            label="Email"
          />
          <TextField
            type="password"
            name="password"
            className={classes.input}
            value={password}
            onChange={handleChange("password")}
            label="Mot de passe"
            error={Boolean(error)}
            helperText={error}
          />
          <div className={classes.buttons}>
            <Link
              color="secondary"
              underline="hover"
              className={classes.forgot}
              onClick={onForgot}
            >
              Mot de passe oublié ?
            </Link>
            <Button type="submit" variant="contained" color="primary">
              Connecter
            </Button>
          </div>
        </form>
      </Loader>
    </div>
  );
};

export default withStyles(styles)(LoginForm);
